import React from 'react';
import {
  elementAttributesToProps,
  RehydratorFunction,
} from '@tr-digital/react-rehydrate';
import { IBadgeProps } from '../types';
import { Badge } from '../Badge';

const rehydrator: RehydratorFunction = async (domNode) => {
  const props: IBadgeProps = elementAttributesToProps(domNode);

  return Promise.resolve(<Badge {...props} />);
};

export default rehydrator;
